module.exports = __webpack_public_path__ + "static/media/instagram.7d0c2ee1.png";